
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz, ImagenMasivo } from '../../controlador';

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorInterfaz;
        public get Imagenes() { return this.Controlador.Imagenes; }
        public get Estado() { return this.Controlador.Vista.Estado; }
        public set Estado( x: string ) { this.Controlador.Vista.Estado = x; }
        public ComenzarDeNuevo: boolean = false;
        public Actual: ImagenMasivo = null;
        public Completadas: number = 0;
        public Errores: number = 0;
        public Progreso: number = 0;
        public Cargando: boolean = false;

        public async Comenzar()
        {
            let total = this.Imagenes.length;
            this.Errores = 0;
            this.Completadas = 0;
            this.Progreso = 0;
            this.Cargando = true;
            this.Estado = 'cargando';

            for ( let imagen of this.Imagenes )
            {
                this.Actual = imagen;
                let e = await imagen.Subir();
                if ( e )
                {
                    this.Completadas++;
                } else
                {
                    this.Errores++;
                }
                this.Progreso = Math.round( ( ( ( this.Errores + this.Completadas ) / total ) * 100 ) );
                console.log( this.Progreso );
            }

            this.Progreso = 100;
            this.Actual = null;
            this.Cargando = false;
            this.ComenzarDeNuevo = true;
            this.Estado = 'completado';


        }

        public async DeNuevo()
        {
            let ee = this.Imagenes.filter( x => x.Completado ).map( a => a.Id );

            for ( let e of ee )
            {
                this.Imagenes.splice( this.Imagenes.findIndex( x => x.Id == e ), 1 );
            }

            for ( let e of this.Imagenes )
            {
                e.Completado = false;
                e.Error = false;
            }

            this.Progreso = 0;
            this.ComenzarDeNuevo = false;
            this.Estado = '';
        }

        public Refresh: boolean = true;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
